import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import CreateCampaignDialogErrorMixin from './create-campaign-dialog-error-mixin';

@Component
export default class CreateCampaignDialogFlowPathErrorsMixin extends mixins(CreateCampaignDialogErrorMixin) {
  getPathErrorCondition(ruleIndex: number, pathIndex: number): any[] {
    return [
      'rules', ruleIndex + 1,
      'paths', pathIndex + 1,
    ];
  }

  get emptyLandingsCondition() {
    return ['landings', 1, 'VALIDATION_FLOW_PATH_AT_LEAST_ONE_LANDING'];
  }

  get isEmptyLandingsError() {
    return this.getEmptyEntityError(this.emptyLandingsCondition);
  }

  get emptyOffersCondition() {
    return ['offers', 1, 'VALIDATION_FLOW_PATH_AT_LEAST_ONE_OFFER'];
  }

  get isEmptyOffersError() {
    return this.getEmptyEntityError(this.emptyOffersCondition);
  }

  get pathWeigthErrorCondition() {
    return [ 'weight' ];
  }

  get isWeigthError() {
    return this.getInvalidFieldsError(this.pathWeigthErrorCondition);
  }

  get weigthErrorMessages() {
    return this.getMessages(this.isWeigthError);
  }

  get pathNameErrorCondition() {
    return [ 'name' ];
  }

  get isNameError() {
    return this.getInvalidFieldsError(this.pathNameErrorCondition);
  }

  get nameErrorMessages() {
    return this.getMessages(this.isNameError);
  }
}